//Libs
import React from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';
//Imagens
import logo from '../images/logo.png';

const styles = (theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        minWidth: '180px',
        width: '40%'
    }
});

/**
 * Renderiza uma página com o logo do sistema
 * @param {Object} props Propriedades do componente
 * @param {*} props.classes Classes CSS do componente
 * @param {*} props.children Componentes a serem renderizados dentro
 */
function AvatarPage({ classes, children }) {
    return (
        <Container maxWidth="xs">
            <CssBaseline />
            <Paper elevation={2} className={classes.paper}>
                <img className={classes.avatar} src={logo} alt="Vitalize" />
                { children }
            </Paper>
        </Container>
    );
}

AvatarPage.propTypes = {
    classes: PropTypes.shape({
        paper: PropTypes.string,
        avatar: PropTypes.string
    }),
    children: PropTypes.any
};

export default withStyles(styles)(AvatarPage);